import React from 'react';
import { useBMTheme } from '../../theme';
import BMButton from '../Button/BMButton';
import { View } from 'react-native';
export default function BMButtonIcon({ Icon, role = 'SECONDARY', size = 'NORMAL', timerDuration, disabled, loading, onPress, onTimerEnd, iconStyle, testID, }) {
    const { BMComponents } = useBMTheme();
    const invertStyle = {
        backgroundColor: BMComponents.BMUiButtonBgcolorSecondaryOndark,
        activeBackgroundColor: BMComponents.BMUiButtonBgcolorSecondaryOndarkHovertap,
        color: BMComponents.BMUiButtonInkSecondaryOndark,
        borderColor: 'transparent',
    };
    const customButtonStyle = role === 'INVERT' ? invertStyle : null;
    const buttonWidth = {
        NORMAL: BMComponents.BMUiButtonHeightNormal,
        LARGE: BMComponents.BMUiButtonHeightLarge,
        INSET: BMComponents.BMUiButtonHeightInset,
    };
    return (<View style={{
            width: buttonWidth[size],
        }}>
      <BMButton onPress={onPress} label={null} role="SECONDARY" buttonStyle={customButtonStyle} size={size} timerDuration={timerDuration} disabled={disabled} loading={loading} TrailingIcon={Icon} onTimerEnd={onTimerEnd} iconStyle={iconStyle} testID={testID} stretchable/>
    </View>);
}
